import { gql } from '@apollo/client'

export default gql(`
    mutation batchUpdateVirtualContentItem($contents: [UpdateContentItemInput] $project: String $module: String!) {
        batchUpdateVirtualContentItem(input: $contents project: $project module: $module) {
            id
        }
    }`
)
